module.exports = __webpack_public_path__ + "img/neudorf-review-filter.14e36cca.webp";